var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BackdataCard,{attrs:{"title":'산출비율 정보',"headers":_setup.outputRatioHeaders,"items":_setup.outputRatioData,"openEditDialog":_setup.openEditDialog,"loading":_setup.isLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }